module.exports = __webpack_public_path__ + "media/images/new-ui-images/info-icon-8eec268d0c55c8a5019f861767b1ef4c.svg";